export const getSeventhFlowId = state => state.seventhFlows.seventhFlow.id;
export const getSeventhFlowData = state => state.seventhFlows.seventhFlow;
export const seventhFlowIsFetching = state => state.seventhFlows.loading;